import { render, staticRenderFns } from "./references.vue?vue&type=template&id=3228b589"
import script from "./references.vue?vue&type=script&lang=ts"
export * from "./references.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiRating: require('/vercel/path0/components/ui/rating.vue').default,UiContainer: require('/vercel/path0/components/ui/container.vue').default})
